import axios from 'axios';
import { API_URL } from '../../global/components/Constants';

export const getUserOrgs = async () => {
  
  try {
    
    const response = await axios.get(`${API_URL}organization/user_organizations`, {
      withCredentials: true
    });
    const obj = response.data;
    if(obj.Success){
        if(obj.Data.length > 0){
          return obj.Data;
        }
    }

    return [];

  } catch (error) {
    return [];
  }
};

export const getCategories = async () => {
  try {
    const response = await axios.get(`${API_URL}utility/categories`);
    const obj = response.data;
    if(obj.Success){
        if(obj.Data.length > 0){
          return obj.Data;
        }
    }
    return [];
  } catch (error) {
    return [];
  }
};

export const getCategory = async (slug) => {
  try {
    const response = await axios.get(`${API_URL}utility/category_by_slug?slug=${slug}`);
    const obj = response.data;
    if(obj.Success){
        if(obj.Data != null){
          return obj.Data;
        }
    }
    return null;
  } catch (error) {
    return null;
  }
};
